import React from 'react';
import { Link } from 'react-router-dom';

const IntroFeature = ({ title, paragraph, image, link, linkText }) => {
  const normalizedLink = link || '/';
  const isInternalLink = normalizedLink.startsWith('/');
  const LinkComponent = isInternalLink ? Link : 'a';
  const linkProps = isInternalLink ? { to: normalizedLink } : { href: normalizedLink };

  return (
    <div className="feature">
      <div
        className="feature-icon mb-5 inline-flex items-center justify-center overflow-hidden rounded-[10%] shadow-md"
        style={{ borderRadius: '10%', overflow: 'hidden', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}
      >
        <img 
          src={`/profile/${image}`} 
          alt={title} 
          style={{ 
            height: '300px', 
            width: '300px', 
            objectFit: 'cover', 
            borderRadius: '10%' 
          }} 
        />
      </div>
      <h3 className="text-3xl">{title}</h3>
      <p className='text-base leading-relaxed'>{paragraph}</p>
      <LinkComponent {...linkProps} className="icon-link inline-flex items-center justify-center gap-1.5 pb-4 text-link-accent">
        <span>{linkText}</span>
        <img className="h-4 w-4 shrink-0" src="/icons/arrow-up-right-square.svg" alt="" aria-hidden="true" />
      </LinkComponent>
    </div>
  );
};

export default IntroFeature;
